import React from 'react';

export const props = {
  form: null,
  email: null,
  token: null,
  onChange: () => {},
  onDiscard: () => {}
};


const Context = React.createContext(props);

export default Context;

export const withForm = Compoment => props => {
  return <Context.Consumer>
    {(context) => <Compoment {...props} {...context} />}
  </Context.Consumer>
}